module.exports = __webpack_public_path__ + "static/media/Knob6.276d1f4e.png";